// extracted by mini-css-extract-plugin
export default {"error_container":"error_error_container__d8x70","error_size_image":"error_error_size_image__ziUnl","error_fs_text_warning":"error_error_fs_text_warning__ILoI+"};